import axios from "axios";

// const baseURL = "http://localhost:3001/api";

// const baseURL = "http://localhost:5000/api";
//const baseURL = "http://35.189.27.162:5000/api";
const baseURL = "http://intophomes.co.nz:5000/api";
export default {
    // Saves a book to the database
    login: function(user) {
        return axios.post(baseURL + "/admin/login", user);
    },

    forgot: function(email) {
        return axios.post(baseURL + "/admin/forgot", email);
    },

    register: function(user) {
        return axios.post(baseURL + "/auth/users/register", user);
    },

    changePassword: function(user) {
        return axios.post(baseURL + "/admin/update", user);
    },

    getWorkers: function() {
        return axios.get(baseURL + "/users");
    },

    register_site: function(name) {
        return axios.post(baseURL + "/site/new", name);
    },
    getSites: function() {
        return axios.get(baseURL + "/sites");
    },
    getHistoryByAllType: function() {
        return axios.get(baseURL + "/allhistory");
    },
    updateSite: function(id, active) {
        return axios.put(baseURL + `/site/${id}`, {"active": active});
    },
    updateSiteName: function(id, name) {
        return axios.put(baseURL + `/site/update/${id}`, {"name": name});
    },

    register_type: function(body) {
        return axios.post(baseURL + "/type/new", body);
    },
    getTypes: function() {
        return axios.get(baseURL + "/types");
    },
    updateTypeStatus: function(id, active) {
        return axios.put(baseURL + `/type/${id}`, {"active": active});
    },
    updateType: function(id, body) {
        return axios.put(baseURL + `/type/update/${id}`, body);
    },
    getHistory: function(key) {
        return axios.get(baseURL + `/history?search=${key}`);
    },
    updateHistory: function(body) {
        return axios.put(baseURL + "/history/update", body);
    },
    getHistoryByType: function(id) {
        return axios.get(baseURL + `/history/type/${id}`);
    },
    getRecordInformation: function() {
        return axios.get(baseURL + "/recordinstruction");
    },
};
